<template>
  <div class="d-flex align-items-center flex-column mt-5 mb-5">
      <a href="#" class="btn">PLAY NOW</a>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
a {
  font-size: 1.5rem;
  padding: 1rem 3rem;
  color: #f4f4f4;
  text-transform: uppercase;
}

a:hover {
  color: rgb(92, 83, 255);
}

.btn {
  text-decoration: none;
  border: 1px solid rgb(80, 75, 187);
  background-color: rgba(0, 0, 0, 0.658);
  position: relative;
  overflow: hidden;
}

.btn:hover {
  box-shadow: 1px 1px 20px 10px rgb(78, 73, 160);
}

.btn:before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    120deg,
    transparent,
    rgb(42, 39, 92),
    transparent
  );
  transition: all 650ms;
}

.btn:hover:before {
  left: 100%;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  h1 {
    font-size: 20px;
  }
  a {
    font-size: 1rem;
  }
}
</style>